export default __webpack_public_path__ + "static/media/check-up.7e639942.svg";